import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import snackbarReducer from '../api/snackbarSlice';
import rootSaga from '../api/rootSaga';
import loaderReducer from '../api/loader/loaderSlice';
import authReducer from '../api/auth/authSlice';
import userReducer from '../api/user/userSlice';
import orgReducer from '../api/organizations/orgSlice';
import subscriptionReducer from '../api/subscription/subscriptionSlice';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    user: userReducer,
    org: orgReducer,
    subscription: subscriptionReducer,
    snackbar: snackbarReducer,
    loader: loaderReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
